/**
 * RefineFiltersLink
 *
 * View that controls the header from the best restaurants search
 * results. Mainly includes the "refine" link and the hamburger.
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.RefineFiltersLink');

OT.Redesign.Views.RefineFiltersLink = Backbone.ViewManager.BaseView.extend({
    el: '#header',

    events: {
        'click #refine-filters-link': 'showRefineModal'
    },

    initialize: function () {
    },

    showRefineModal: function (e) {
        e.preventDefault();
        OT.Search.views.refineFiltersModal.show();
    }
});
